import { render, staticRenderFns } from "./centurion-shopping.vue?vue&type=template&id=0c2ae860&scoped=true&"
import script from "./centurion-shopping.vue?vue&type=script&lang=js&"
export * from "./centurion-shopping.vue?vue&type=script&lang=js&"
import style0 from "./centurion-shopping.vue?vue&type=style&index=0&id=0c2ae860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ae860",
  null
  
)

export default component.exports